module.exports = __webpack_public_path__ + "img/grok.35c9bdf1.svg";